/**
 * Canonical 16-byte → UUID-string rendering, shared by the v5 and v7 generators
 * so the two siblings can't drift into two spellings of one format.
 */

/** Render 16 bytes as a canonical lowercase UUID string. */
export function bytesToUuid(bytes: Uint8Array): string {
  const hex: string[] = [];
  for (let i = 0; i < 16; i++) hex.push(bytes[i].toString(16).padStart(2, '0'));
  return (
    `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-` +
    `${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}`
  );
}

/**
 * Stamp RFC 9562 version + variant bits in place and return the same buffer.
 * `version` is the 4-bit version nibble (5 for name-based SHA-1, 7 for
 * time-ordered); the variant is always the RFC's `10xx`.
 */
export function setUuidVersion(bytes: Uint8Array, version: number): Uint8Array {
  bytes[6] = (version << 4) | (bytes[6] & 0x0f);
  bytes[8] = 0x80 | (bytes[8] & 0x3f);
  return bytes;
}
